import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { deleteVideo, fetchVideoList } from "../actions/video";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import { statusRender } from "../utils/cellRenderTable";
import { createDateColumn } from "../utils/agGridDateColumn";

const VideoList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { videoList } = useSelector((state) => state.videoReducer);

  //breadcrumb
  const translateModule = "video";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchVideoList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/video-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(deleteVideo(pageId));
  };

  const columnDefs = [
    {
      headerName: "Naziv",
      field: "name",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Kurs",
      field: "courseName",
      filter: "agSetColumnFilter",
    },
    {
      headerName: "Kanal",
      field: "channelName",
      filter: "agSetColumnFilter",
    },
    {
      headerName: "JWPlayer video",
      field: "videoTargetId",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "JWPlayer trailer video",
      field: "trailerTargetId",
      filter: "agTextColumnFilter",
      width: 210,
    },
    {
      headerName: "Cena",
      field: "price",
      filter: "agNumberColumnFilter",
      width: 140,
    },
    {
      headerName: "Sekcija",
      field: "sectionType",
      filter: "agSetColumnFilter",
      valueGetter: (params) => {
        if (!params.data || !params.data.sectionType) return null;
        switch (params.data.sectionType) {
          case "MICRO":
            return "MIKROKAT";
          case "MINI":
            return "MINIKAT";
          case "MASTER":
            return "MASTERKAT";
          default:
            return "";
        }
      },
    },
    {
      headerName: "Aktivan",
      field: "active",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      flex: 1,
      minWidth: 140,
      valueGetter: (params) => {
        if (params.data?.active === true) return "Aktivan";
        if (params.data?.active === false) return "Neaktivan";
        return "";
      },
    },
    {
      headerName: "Na prodaju",
      field: "shoppable",
      filter: "agSetColumnFilter",
      width: 140,
    },
    {
      headerName: "Na popustu",
      field: "discount",
      filter: "agSetColumnFilter",
      width: 140,
    },
    {
      headerName: "Besplatan",
      field: "free",
      filter: "agSetColumnFilter",
      width: 140,
    },
    {
      headerName: "Cena sa popustom",
      field: "discountPrice",
      filter: "agNumberColumnFilter",
    },

    createDateColumn("Popust od", "discountStart"),
    createDateColumn("Popust do", "discountEnd"),
    createDateColumn("Datum kreiranja", "createdAt"),
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        gridStateKey="video-list"
        reloadData={() =>
          dispatch(fetchVideoList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        gridStateKey="video-list"
        rowData={videoList}
        columnDefs={columnDefs}
        buttonLink={`/video-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
      />
    </Fragment>
  );
};

export default VideoList;
